import {
  Dropdown,
  PaginatedDropdownList,
  ReturnLogsTypeEnum,
  UsersListListData,
  usersListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect, RangePickerFilter } from '@crm/components'
import { defaultFiltersMultipleValues } from '@crm/utils'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Select, Tooltip } from 'antd'

export const LogsFilter = () => {
  const { t } = useLocales()
  const { params, updateQuery } = useQueryUpdate()

  const created_byValue = defaultFiltersMultipleValues(params?.created_by)

  const typeValue = Array.isArray(params?.type)
    ? params?.type
    : params?.type
    ? [params?.type]
    : undefined

  return (
    <>
      <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
        value={created_byValue}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('logs.who')}
        getQueryFunction={usersListListInfiniteOptions}
        onChange={(created_by) => updateQuery({ created_by })}
        baseOptions={{
          query: {
            preference: params?.created_by
          }
        }}
        mode="multiple"
        maxTagCount={1}
        maxTagTextLength={6}
      />

      <Select
        allowClear
        mode="multiple"
        className="select-min-width"
        placeholder={t('logs.type')}
        value={typeValue}
        onChange={(type) => updateQuery({ type })}
        options={Object.values(ReturnLogsTypeEnum).map((item) => ({
          label: t(`logs.${item}`, item),
          value: item
        }))}
        maxTagCount={1}
        maxTagTextLength={6}
      />

      <Tooltip title={`${t('created_at_from')} - ${t('created_at_to')}`}>
        <RangePickerFilter
          fromParam="created_at_from"
          toParam="created_at_to"
          placeholder={[t('created_at_from'), t('created_at_to')]}
        />
      </Tooltip>
    </>
  )
}
